import React from 'react';
import { Link } from 'react-router-dom';

const GettingStarted: React.FC = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-primary-600 text-white py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-bold mb-4">시작하기 가이드</h1>
          <p className="text-xl text-primary-100">
            5분 안에 첫 API 호출을 완성하세요
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="space-y-8">
          {/* Step 1 */}
          <div className="bg-white rounded-lg shadow p-8">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-primary-600 text-white rounded-full flex items-center justify-center text-xl font-bold">
                  1
                </div>
              </div>
              <div className="ml-6 flex-grow">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">회원가입</h2>
                <p className="text-gray-600 mb-4">
                  무료 계정을 생성하고 API 키를 발급받으세요. 이메일 인증만으로 즉시 시작할 수 있습니다.
                </p>
                <Link
                  to="/signup"
                  className="inline-block bg-primary-600 text-white px-6 py-2 rounded hover:bg-primary-700 transition"
                >
                  회원가입하기
                </Link>
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="bg-white rounded-lg shadow p-8">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-primary-600 text-white rounded-full flex items-center justify-center text-xl font-bold">
                  2
                </div>
              </div>
              <div className="ml-6 flex-grow">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">API 키 발급</h2>
                <p className="text-gray-600 mb-4">
                  대시보드에서 개발용 또는 프로덕션용 API 키를 발급받으세요.
                </p>
                <div className="bg-gray-900 text-gray-100 p-4 rounded font-mono text-sm">
                  sk_test_1234567890abcdefghijklmnop
                </div>
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="bg-white rounded-lg shadow p-8">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-primary-600 text-white rounded-full flex items-center justify-center text-xl font-bold">
                  3
                </div>
              </div>
              <div className="ml-6 flex-grow">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">첫 API 호출</h2>
                <p className="text-gray-600 mb-4">
                  아래 예제 코드를 실행하여 첫 API 호출을 해보세요.
                </p>
                <div className="bg-gray-900 text-gray-100 p-4 rounded font-mono text-sm overflow-x-auto">
                  <pre>{`curl -X GET "https://api.dataapi.com/v1/realestate/price" \\
  -H "Authorization: Bearer YOUR_API_KEY"`}</pre>
                </div>
              </div>
            </div>
          </div>

          {/* Step 4 */}
          <div className="bg-white rounded-lg shadow p-8">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-primary-600 text-white rounded-full flex items-center justify-center text-xl font-bold">
                  4
                </div>
              </div>
              <div className="ml-6 flex-grow">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">문서 탐색</h2>
                <p className="text-gray-600 mb-4">
                  API 문서를 탐색하고 필요한 데이터를 찾아보세요.
                </p>
                <div className="space-x-4">
                  <Link
                    to="/api-docs/realestate"
                    className="inline-block text-primary-600 hover:text-primary-700 font-semibold"
                  >
                    부동산 API →
                  </Link>
                  <Link
                    to="/api-docs/business"
                    className="inline-block text-primary-600 hover:text-primary-700 font-semibold"
                  >
                    사업자 API →
                  </Link>
                  <Link
                    to="/api-docs/card"
                    className="inline-block text-primary-600 hover:text-primary-700 font-semibold"
                  >
                    카드 API →
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 도움이 필요하신가요? */}
        <div className="mt-12 bg-primary-50 border border-primary-200 rounded-lg p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">도움이 필요하신가요?</h3>
          <p className="text-gray-600 mb-6">
            문제가 발생하거나 질문이 있으시면 언제든지 문의해주세요
          </p>
          <div className="space-x-4">
            <Link
              to="/support/faq"
              className="inline-block bg-white text-primary-600 border border-primary-600 px-6 py-2 rounded hover:bg-primary-50 transition"
            >
              FAQ 보기
            </Link>
            <Link
              to="/support/community"
              className="inline-block bg-primary-600 text-white px-6 py-2 rounded hover:bg-primary-700 transition"
            >
              커뮤니티 방문
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GettingStarted;
